export const PayBridges = {
  en: {
    'PayBridge Tokens': 'PayBridge tokens',
    'Create PayBridge Token': 'Create PayBridge token',
    Company: 'Company',
    Location: 'Location',
    Notes: 'Notes',
    Online: 'Online',
    Created: 'Created',
    'Last connection': 'Last connection',
    Terminals: 'Terminals',
    'Agent version': 'Agent version',
    '1.x (legacy)': '1.x (legacy)',
    'Works with': 'Works with',
    'PayBridge versions hint':
      'PayBridge 1.x works only with legacy sales. PayBridge 2.x works only with the new sales (v2). To switch a location to v2, install PayBridge 2.x with this token.',
  },
  uk: {
    'PayBridge Tokens': 'PayBridge токени',
    'Create PayBridge Token': 'Створити PayBridge токен',
    Company: 'Компанія',
    Location: 'Локація',
    Notes: 'Нотатки',
    Online: 'Онлайн',
    Created: 'Створено',
    'Last connection': 'Останнє підключення',
    Terminals: 'Термінали',
    'Agent version': 'Версія агента',
    '1.x (legacy)': '1.x (стара)',
    'Works with': 'Працює з',
    'PayBridge versions hint':
      'PayBridge 1.x працює лише зі старими продажами. PayBridge 2.x працює лише з новими продажами (v2). Щоб перевести локацію на v2, встановіть PayBridge 2.x з цим токеном.',
  },
};

export const PayBridgeForm = {
  en: {
    ...PayBridges.en,
    'PayBridge Token': 'PayBridge token',
    'New PayBridge Token': 'New PayBridge token',
    'Edit PayBridge Token': 'Edit PayBridge token',
    'Update PayBridge Token': 'Update PayBridge token',
    'Cashier Terminals': 'Cashier terminals',
    'MAC Address': 'MAC address',
    'Auth Token': 'Auth token',
    'Regenerate Token': 'Regenerate token',
    'Auth Token Created': 'Auth token created',
    'Copy this token now. It will not be shown again.':
      'Copy this token now. It will not be shown again.',
    'Successfully copied': 'Successfully copied',
    'Close and go to list': 'Close and go to list',
  },
  uk: {
    ...PayBridges.uk,
    'PayBridge Token': 'PayBridge токен',
    'New PayBridge Token': 'Новий PayBridge токен',
    'Edit PayBridge Token': 'Редагування PayBridge токена',
    'Update PayBridge Token': 'Оновити PayBridge токен',
    'Cashier Terminals': 'Касові термінали',
    'MAC Address': 'MAC адреса',
    'Auth Token': 'Токен авторизації',
    'Regenerate Token': 'Перегенерувати токен',
    'Auth Token Created': 'Токен авторизації створено',
    'Copy this token now. It will not be shown again.':
      'Скопіюйте цей токен зараз. Він більше не буде показаний.',
    'Successfully copied': 'Успішно скопійовано',
    'Close and go to list': 'Закрити та перейти до списку',
  },
};
